module.exports = __webpack_public_path__ + "img/broadcast-plug.19b0bb4a.jpg";